import { APP_KAYAK_BIDDING_API_ENDPOINT } from "constants/api_urls";
import "../style/chartContainer.scss";

export const urlActiveMultiplierHistoryPopover = {
    "KAYAK": `${APP_KAYAK_BIDDING_API_ENDPOINT}`,
}